import { InfoItemProps } from "@/components/organisms";
import { defaultDateFormat } from "@/core/date";
import i18n from "@/i18n";

export const panelDescriptionSchema = (description: MyBrokerApi.DescriptionDetails): InfoItemProps[] => [
    {
        key: "address",
        label: i18n.t("Common.Address"),
        value: description.address,
    },
    {
        key: "complementaryName",
        label: i18n.t("InsuredGood.Details.Building.ComplementaryName"),
        value: description.complementaryName,
    },
    {
        key: "type",
        label: i18n.t("Common.Type"),
        value: description.type?.name,
    },
    {
        key: "description",
        label: i18n.t("Common.Description"),
        value: description.description?.name,
    },
    {
        key: "constructionAssignment",
        label: i18n.t("InsuredGood.Details.Building.Assignment"),
        value: description.constructionAssignment?.name,
    },
    {
        key: "genre",
        label: i18n.t("InsuredGood.Details.Building.Genre"),
        value: description.genre?.name,
    },
    {
        key: "constructionType",
        label: i18n.t("InsuredGood.Details.Building.ConstructionType"),
        value: description.constructionType?.name,
    },
    {
        key: "rooftype",
        label: i18n.t("InsuredGood.Details.Building.RoofType"),
        value: description.roofType?.name,
    },
];

export const panelContextSchema = (context: MyBrokerApi.ContextDetails): InfoItemProps[] => [
    {
        key: "ownerType",
        label: i18n.t("InsuredGood.Details.Building.OwnerType"),
        value: context.ownerType?.name,
    },
    {
        key: "residenceType",
        label: i18n.t("InsuredGood.Details.Building.ResidenceType"),
        value: context.residenceType?.name,
    },
    {
        key: "usage",
        label: i18n.t("InsuredGood.Details.Building.Usage"),
        value: context.use?.name,
    },
    {
        key: "commerceUse",
        label: i18n.t("InsuredGood.Details.Building.CommerceUse"),
        value: context.commerceUse?.name,
    },
    {
        key: "occupation",
        label: i18n.t("InsuredGood.Details.Building.Occupation"),
        value: context.occupation?.name,
    },
];

export const panelProtectionSchema = (protection: MyBrokerApi.SystemProtectionDetails): InfoItemProps[] => [
    {
        key: "antiTheftProtection",
        label: i18n.t("InsuredGood.Details.Building.AntiTheftProtection"),
        value: protection.antiTheftProtection ? i18n.t("Common.Yes") : "",
    },
    {
        key: "antiTheftMeasure1",
        label: i18n.t("InsuredGood.Details.Building.AntiTheftMeasureX", { number: 1 }),
        value: protection.antiTheftMeasure1?.name,
    },
    {
        key: "antiTheftMeasure2",
        label: i18n.t("InsuredGood.Details.Building.AntiTheftMeasureX", { number: 2 }),
        value: protection.antiTheftMeasure2?.name,
    },
    {
        key: "antiTheftMeasure3",
        label: i18n.t("InsuredGood.Details.Building.AntiTheftMeasureX", { number: 3 }),
        value: protection.antiTheftMeasure3?.name,
    },
    {
        key: "antiTheftMeasure4",
        label: i18n.t("InsuredGood.Details.Building.AntiTheftMeasureX", { number: 4 }),
        value: protection.antiTheftMeasure4?.name,
    },
    {
        key: "antiTheftMeasure5",
        label: i18n.t("InsuredGood.Details.Building.AntiTheftMeasureX", { number: 5 }),
        value: protection.antiTheftMeasure5?.name,
    },
    {
        key: "antiTheftMeasure6",
        label: i18n.t("InsuredGood.Details.Building.AntiTheftMeasureX", { number: 6 }),
        value: protection.antiTheftMeasure6?.name,
    },
];

export const panelOversightSchema = (oversight: MyBrokerApi.ConstructionOversightDetails): InfoItemProps[] => [
    {
        key: "constructionDate",
        label: i18n.t("InsuredGood.Details.Building.ConstructionDate"),
        value: defaultDateFormat(oversight?.constructionDate),
    },
    {
        key: "estimatedDelivery",
        label: i18n.t("InsuredGood.Details.Building.EstimatedDelivery"),
        value: defaultDateFormat(oversight?.estimatedDelivery),
    },
];
